import { render, staticRenderFns } from "./OnboardingNotifications.vue?vue&type=template&id=332c4880&"
import script from "./OnboardingNotifications.vue?vue&type=script&lang=js&"
export * from "./OnboardingNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports